import { request } from '../utils/request';

// eslint-disable-next-line import/prefer-default-export
export const callMLServiceApi = data =>
  request.post('/superadmin/ml-service-api', data);
